/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
        .directive('accGetLink', ['$modal', 'nodeModalAction', '$translate', function ($modal, nodeModalAction, $translate) {
            return {
                link: function ($scope, elem) {
                    elem.on('click', function () {
                        nodeModalAction($scope, {
                            modalController: "NodeGetLinkController",
                            modalType: "confirm",
                            modalAction: "get_link",
                            modalBodyTemplate: "nodes/get_link",
                            modalActionButton:  $translate.instant('Get Link'),
                            modalCancelButton:  $translate.instant('Cancel'),
                            modalTitle: $translate.instant('Get link to %{node_name}', {node_name: $scope.node['name']}),
                            modalNotifications: true
                        });
                    });
                }
            }
        }]);